import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import Button from '../Button';

export default () => (
  <>
    <Heading level={1}>Primary Button</Heading>
    <Spacer size={16} />
    <Text>
      By default, rendering a <Code>{'<Button />'}</Code> component will render
      the primary button type. Alternatively a primary button can be rendered by
      setting <Code>{'type="primary"'}</Code> on the <Code>{'<Button />'}</Code>{' '}
      component.
    </Text>
    <Spacer size={16} />
    <Text>
      By default the current user's competency level will be used to determine
      the primary button's background color.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Button>Label</Button>
        <Spacer size={6} />
        <Text>Active</Text>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center" expand={false}>
        <Button disabled={true}>Label</Button>
        <Spacer size={6} />
        <Code>{'disabled={true}'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={24} />
    <Heading level={2}>Overriding Competency Level</Heading>
    <Spacer size={16} />
    <Text>
      When the <Code>competency</Code> prop is set to a valid value it will
      override the current user's competency level and the corresponding
      background color for the button will be used instead.
    </Text>
    <Spacer size={16} />
    <FlexView>
      <Button competency={COACH}>Label</Button>
      <Spacer size={6} />
      <Code>{'competency={COACH}'}</Code>
    </FlexView>
    <Spacer size={10} />
    <FlexView>
      <Button competency={BUSINESS_COACH}>Label</Button>
      <Spacer size={6} />
      <Code>{'competency={BUSINESS_COACH}'}</Code>
    </FlexView>
    <Spacer size={10} />
    <FlexView>
      <Button competency={BUSINESS_LEADER}>Label</Button>
      <Spacer size={6} />
      <Code>{'competency={BUSINESS_LEADER}'}</Code>
    </FlexView>
  </>
);
